import { configureStore } from '@reduxjs/toolkit';
import { workerApi } from './Api/workerApi/workerApi';
import { employedsApi } from './Api/employedsApi/employedsApi';
import { contractsApi } from './Api/contractsApi/contractsApi';
import { operationsApi } from './Api/operationsApi/operationsApi';
import { beneficiariesApi } from './Api/beneficiariesApi/beneficiariesApi';
import { checksApi } from './Api/checksApi/checksApi';
import { uncreditedPaymentsApi } from './Api/uncreditedPaymentsApi/uncreditedPaymentsApi';
import popupSlice from './popup/slice';
import dateFilterSlice from './dateFilter/slice';
import beneficiarSlice from './beneficiarDetail/slice';
import webSocketSlice from './webSocket/slice';
import operationInfoSlice from './operationInfo/slice';
import ordersDetailsSlice from './ordersDetails/slice';
import mainInfoSlice from './mainInfo/slice';
import userInfoSlice from './userInfo/slice';
import dateRangeSlice from './dateRange/slice';
import employedsDetailSlice from './employedDetail/slice';
import createProfile from './createProfile/slice';
import authSlice from './auth/slice';
import employedsSlice from './employeds/slice';
import { ordersApi } from './Api/ordersApi/ordersApi';
import { taxesApi } from './Api/taxesApi/taxesApi';
import { employedsWorkSupportApi } from './Api/employedsWorkSupportApi/employedsWorkSupportApi';
import { performersWorkSupport } from './Api/performersWorkSupport/performersWorkSupport';
import { authApi } from './Api/authApi/authApi';
import { employeesApi } from './Api/employeesApi/employeesApi';
import { customersApi } from './Api/customersApi/customersApi';
import { alertsApi } from './Api/alertsApi/alertsApi';
import { usersApi } from './Api/usersApi/usersApi';
import { referencesApi } from './Api/referencesApi/referencesApi';
import { profileApi } from './Api/profileApi/ProfileApi';
import { alertsWorkSupportApi } from './Api/alertsWorkSupportApi/alertsWorkSupportApi';

export const store = configureStore({
  reducer: {
    popup: popupSlice,
    dateFilter: dateFilterSlice,
    mainInfo: mainInfoSlice,
    dateRange: dateRangeSlice,
    websocket: webSocketSlice,
    beneficiarSlice,
    operationInfoSlice,
    ordersDetailsSlice,
    userInfoSlice,
    employedsDetailSlice,
    employeds: employedsSlice,
    createProfile,
    authSlice,
    [workerApi.reducerPath]: workerApi.reducer,
    [beneficiariesApi.reducerPath]: beneficiariesApi.reducer,
    [employedsApi.reducerPath]: employedsApi.reducer,
    [contractsApi.reducerPath]: contractsApi.reducer,
    [operationsApi.reducerPath]: operationsApi.reducer,
    [ordersApi.reducerPath]: ordersApi.reducer,
    [profileApi.reducerPath]: profileApi.reducer,
    [taxesApi.reducerPath]: taxesApi.reducer,
    [alertsWorkSupportApi.reducerPath]: alertsWorkSupportApi.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
    [employedsWorkSupportApi.reducerPath]: employedsWorkSupportApi.reducer,
    [performersWorkSupport.reducerPath]: performersWorkSupport.reducer,
    [checksApi.reducerPath]: checksApi.reducer,
    [uncreditedPaymentsApi.reducerPath]: uncreditedPaymentsApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [employeesApi.reducerPath]: employeesApi.reducer,
    [customersApi.reducerPath]: customersApi.reducer,
    [alertsApi.reducerPath]: alertsApi.reducer,
    [referencesApi.reducerPath]: referencesApi.reducer,
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).concat(
      workerApi.middleware,
      beneficiariesApi.middleware,
      employedsApi.middleware,
      contractsApi.middleware,
      operationsApi.middleware,
      ordersApi.middleware,
      profileApi.middleware,
      taxesApi.middleware,
      alertsWorkSupportApi.middleware,
      usersApi.middleware,
      employedsWorkSupportApi.middleware,
      performersWorkSupport.middleware,
      checksApi.middleware,
      uncreditedPaymentsApi.middleware,
      authApi.middleware,
      employeesApi.middleware,
      customersApi.middleware,
      alertsApi.middleware,
      referencesApi.middleware,
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
